import React from 'react';
import PropTypes from 'prop-types';
import SearchOutlined from '@mui/icons-material/SearchOutlined';
import colors from '../Theme/colors';

const searchPropertyTypes = {
  htmlColor: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  fontSize: PropTypes.oneOf(['small', 'inherit', 'large', 'medium']),
  titleAccess: PropTypes.string,
};

type SearchProperties = PropTypes.InferProps<typeof searchPropertyTypes> & {
  htmlColor?: string;
  className?: string;
  onClick?: () => void;
  fontSize?: 'inherit' | 'large' | 'medium' | 'small';
  titleAccess?: string;
};

const Search = (properties: SearchProperties) => (
  <SearchOutlined
    titleAccess="Search"
    htmlColor={colors.greyDark}
    {...properties}
  />
);

Search.propTypes = searchPropertyTypes;

export default Search;
